module.exports = __webpack_public_path__ + "static/media/logo-with-name.7da0f872.png";